var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white",
    fillOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 24C16.1 24 16.3 23.9 16.5 23.8C16.7 23.6 16.8 23.4 16.8 23.1L17 21.9C16.2 22.1 15.4 22.1 14.6 21.9L14.8 23.1C14.8 23.4 14.9 23.6 15.1 23.8C15.3 23.9 15.5 24 15.8 24ZM22.7 23.8H24.6V12.9C24.6 11.4 23.9 10.4 22.7 10V23.8ZM7 23.8H8.9V10C7.7 10.4 7 11.4 7 12.9V23.8ZM17 21.9C18.2 21.6 19.1 20.7 19.3 19.1L20.5 9.9C19.1 10.2 18.4 11.3 18.1 13L17 21.9ZM14.6 21.9L13.5 13C13.3 11.3 12.5 10.2 11.2 9.9L12.4 19.1C12.6 20.7 13.4 21.6 14.6 21.9ZM22.7 10V9.2C22.7 8.4 22.3 8 21.7 8C21.1 8 20.7 8.4 20.6 9.1L20.5 9.9C21.2 9.8 22 9.8 22.7 10ZM8.9 10C9.3 9.9 9.8 9.8 10.2 9.8C10.5 9.8 10.8 9.8 11.2 9.9L11.1 9.1C10.9 8.3 10.5 8 9.9 8C9.3 8 8.9 8.4 8.9 9.2V10Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.9L16.8 23.1C16.8 23.4 16.7 23.6 16.5 23.8C16.3 23.9 16.1 24 15.8 24C15.5 24 15.3 23.9 15.1 23.8C14.9 23.6 14.8 23.4 14.8 23.1L14.6 21.9M17 21.9C16.2 22.1 15.4 22.1 14.6 21.9M17 21.9C18.2 21.6 19.1 20.7 19.3 19.1L20.5 9.9M17 21.9L18.1 13C18.4 11.3 19.1 10.2 20.5 9.9M14.6 21.9L13.5 13C13.3 11.3 12.5 10.2 11.2 9.9M14.6 21.9C13.4 21.6 12.6 20.7 12.4 19.1L11.2 9.9M22.7 10C23.9 10.4 24.6 11.4 24.6 12.9V23.8H22.7V10ZM22.7 10V9.2C22.7 8.4 22.3 8 21.7 8C21.1 8 20.7 8.4 20.6 9.1L20.5 9.9M22.7 10C22 9.8 21.2 9.8 20.5 9.9M8.9 10V23.8H7V12.9C7 11.4 7.7 10.4 8.9 10ZM8.9 10C9.3 9.9 9.8 9.8 10.2 9.8C10.5 9.8 10.8 9.8 11.2 9.9M8.9 10V9.2C8.9 8.4 9.3 8 9.9 8C10.5 8 10.9 8.3 11.1 9.1L11.2 9.9",
    stroke: "white",
    strokeWidth: 1.3333,
    strokeMiterlimit: 5.3333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMina);
export default __webpack_public_path__ + "static/media/MINA.e70c579a03fdbe043291057d5d522a56.svg";
export { ForwardRef as ReactComponent };